<!-- Hero Start -->
<section class="bg-half-170 bg-light d-table w-100" id="home"
         style="background: url('assets/banners/fe-rio-2.jpg') center center;">
    <div class="bg-overlay bg-overlay-white"></div>
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <div class="col-lg-12 text-center">
                <div class="pages-heading">
                    <h4 class="title mb-0">{{ 'tourism.header' | translate }}</h4>
                </div>
            </div> <!--end col-->
        </div><!--end row-->

        <div class="position-breadcrumb">
            <nav aria-label="breadcrumb" class="d-inline-block">
                <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                    <li class="breadcrumb-item"><a routerLink="/">LASA 2025</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{  'tourism.header' | translate }}</li>
                </ul>
            </nav>
        </div>
    </div> <!--end container-->
</section><!--end section-->

<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--Shape End-->

<!-- Work Start -->
<section class="section">
    <!--end container-->
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">{{  'tourism.day1' | translate }}</h4>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div id="grid" class="row">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <div class="row g-0">
                            <div class="col-md-5">
                                <img src="assets/locais/bluenote.jpg" class="img-fluid" alt="...">
                            </div>
                            <div class="col-md-7">
                                <div class="card-body">
                                    <h5 class="card-title">Blue Note</h5>
                                    <p class="card-text">{{  'tourism.blue-note' | translate }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">{{  'tourism.day2' | translate }}</h4>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div id="grid" class="row">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <div class="row g-0">
                            <div class="col-md-5">
                                <img src="assets/locais/fagulha.jpg" class="img-fluid" alt="...">
                            </div>
                            <div class="col-md-7">
                                <div class="card-body">
                                    <h5 class="card-title">Fagulha Grill e Pizza</h5>
                                    <p class="card-text">{{  'tourism.fagulha' | translate }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section bg-cta" style="background: url('assets/images/copacabana2.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">{{ 'home.ctaOne.header' | translate }}</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">{{ 'home.ctaOne.description' | translate }}</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank" class="btn btn-danger btn-lg"> {{ 'home.ctaOne.button' | translate }}
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<section class="section">
    <div class="row justify-content-center">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">{{  'tourism.day2Ladies' | translate }}</h4>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/aquario.jpg" width="100%" class="rounded" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">AquaRio</h5>
                                <p class="card-text">{{  'tourism.aquaRio' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/artsesc.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Arte Sesc</h5>
                                <p class="card-text">{{  'tourism.arteSesc' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/museu.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Museu do Amanhã</h5>
                                <p class="card-text">{{  'tourism.museu' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/shops.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Shopping Rio Sul</h5>
                                <p class="card-text">{{  'tourism.shopping' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section">
    <div class="row justify-content-center">
        <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
                <h4 class="title mb-4">{{  'tourism.day2Dinner' | translate }}</h4>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/quiosque.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Quiosque DuMare</h5>
                                <p class="card-text">{{  'tourism.quiosque' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section">
    <div class="row justify-content-center">
        <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
                <h4 class="title mb-4">{{  'tourism.day3Tour' | translate }}</h4>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/trem.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Trem do Corcovado</h5>
                                <p class="card-text">{{  'tourism.trem' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/broz.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Restaurante Broz</h5>
                                <p class="card-text">{{  'tourism.broz' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/bondinho.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Bondinho do Pão de Açucar</h5>
                                <p class="card-text">{{  'tourism.bondinho' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section">
    <div class="row justify-content-center">
        <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
                <h4 class="title mb-4">{{  'tourism.day3End' | translate }}</h4>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div id="grid" class="row">
                <div class="card shadow rounded border-0 overflow-hidden">
                    <div class="row g-0">
                        <div class="col-md-5">
                            <img src="assets/locais/palace.jpg" class="img-fluid" alt="...">
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h5 class="card-title">Churrascaria à Confirmar</h5>
                                <p class="card-text">{{  'tourism.churras' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="section bg-cta" style="background: url('assets/images/copacabana3.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">{{'home.ctaThree.header' | translate }}</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">{{'home.ctaThree.description' | translate }}</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank"class="btn btn-danger btn-lg">{{'home.ctaThree.button' | translate }}
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>


<!--end section-->
<!-- Work End -->


<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
